export default providerList => {

    if (! $('.navigation a').length) {
        return;
    }

    let $providerTiles = $('.provider-tile');
    let $navigation = $('.navigation a');
    let $showAll = $('#show-all');
    let currentProvider;

    $navigation.on('click', (event) => {
        let $this = $(event.target);

        if ($('#provider-search').val() !== '') {
            $('#provider-search').val('').trigger('keyup');
        }

        currentProvider = '#' + $this.data("provider-key");
        $navigation.removeClass('active');
        $this.addClass('active');
        $this.parent().addClass('active-li');

        $('.provider-firstletter').not(currentProvider).hide();
        $(currentProvider).show();
        $showAll.show();
    });

    if (window.location.hash) {
        let hash = window.location.hash.substring(1);
        $(`.navigation a[data-provider-key="${hash}"]`).click();
    }

    $showAll.on('click', function () {
        $showAll.hide();
        $('.provider-firstletter').show();
        $(this).parent().removeClass('active-li');
    });

    let searchTerm = '';
    $('#provider-search').on('keyup', function () {
        let $this = $(this);
        searchTerm = $('#provider-search').val();
        $showAll.hide();
        $navigation.removeClass('active');

        if (searchTerm.length >= 3) {
            $('.provider-firstletter').show();
            $showAll.show();
            $(".provider-list li").each(function () {
                if (jQuery(this).text().search(new RegExp(searchTerm, "i")) < 0) {
                    jQuery(this).hide();
                } else {
                    jQuery(this).show();
                }
            });
            $providerTiles.each(function () {
                $this = $(this);
                if ($this.find('li:visible').length === 0) {
                    $this.hide();
                } else {
                    $this.show();
                }
            });
        } else {
            $(".provider-list li").show();
            $providerTiles.show();
        }

        $navigation.removeClass('active').parent().removeClass('active-li');
    });
};
